import React from "react";
import { importRetry } from "utils/importTools";
const LoginPage = React.lazy(() => importRetry(() => import("page/auth")));
export const routes = [
    { path: "/", element: <LoginPage /> },
];
